import React from "react";
import { useAuth } from "../app/providers/AuthProvider";
import { BaseLayout } from "../components/baseLayout";
import { Card } from "../components/card";
import { Modal } from "../components/modal";
import { DetailPlanning } from "../components/detailPlanning";
import { authInterceptor } from "../services/axios/interceptor";

function Home() {
  const { user } = useAuth();
  const [allPlanning, setAllPlanning] = React.useState([]);
  const [planning, setPlanning] = React.useState({});
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  function handleOpenModal(planId) {
    async function fetchData() {
      try {
        const res = await authInterceptor.get(`/api/operations/planning/${planId}`);
        setPlanning(res.data);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  React.useEffect(() => {
    async function fetchData() {
      try {
        const res = await authInterceptor.get("/api/operations/planning/");
        setAllPlanning(res.data);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  const displayName = user?.first_name || user?.name || user?.email || "there";

  return (
    <BaseLayout>
      <div className="row">
        <div className="col-sm-6 mb-4 mb-xl-0">
          <div className="d-lg-flex align-items-center">
            <div>
              <h3 className="text-dark font-weight-bold mb-2">
                Hi {displayName}, welcome back!
              </h3>
              <h6 className="font-weight-normal mb-2">
                Last login was 23 hours ago.
              </h6>
            </div>
            <div className="ml-lg-5 d-lg-flex">
              <button
                type="button"
                className="btn bg-white btn-icon ml-2"
                data-toggle="tooltip"
                data-placement="right"
                title="Subscripción activa"
              >
                <i className="mdi mdi-emoticon-happy text-success"></i>
              </button>
              <button
                type="button"
                className="btn bg-white btn-icon ml-2"
                data-toggle="tooltip"
                data-placement="right"
                title="Tu subscripción termina en 10 dias"
              >
                <i className="mdi mdi-alert text-warning"></i>
              </button>
              <button
                type="button"
                className="btn bg-white btn-icon ml-2"
                data-toggle="tooltip"
                data-placement="right"
                title="Tu subscripción termina en 5 dias"
              >
                <i className="mdi mdi-alert text-danger"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12">
          <div className="row">
            {allPlanning.map((plan) => (
              <Card
                key={plan.id}
                plan={plan}
                onOpenModal={handleOpenModal}
              />
            ))}
          </div>
        </div>
      </div>
      {/* Fix: was `!!openModal` (always true — openModal is a function reference).
          Now uses the `isModalOpen` boolean state. */}
      {isModalOpen && (
        <Modal title={planning.title}>
          <DetailPlanning onCloseModal={handleCloseModal} planning={planning} />
        </Modal>
      )}
    </BaseLayout>
  );
}

export { Home };
